import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../utils/api';
import '../styles/global.css';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-card">
          <h1 className="login-title">Leadiox</h1>
          <p className="login-subtitle">Invalid Reset Link</p>
          <p className="text-muted text-sm" style={{ textAlign: 'center', padding: '16px 0' }}>This password reset link is invalid or has expired.</p>
          <div className="login-toggle">
            <Link to="/forgot-password">Request a new reset link</Link>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-title">Leadiox</h1>
        <p className="login-subtitle">Set New Password</p>

        {done ? (
          <div>
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>&#10003;</div>
              <p style={{ fontWeight: 500, marginBottom: 8 }}>Password updated</p>
              <p className="text-muted text-sm">Your password has been reset. You can now sign in with your new password.</p>
            </div>
            <div className="login-toggle" style={{ marginTop: 20 }}>
              <Link to="/login">Sign In</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="login-error">{error}</div>}
            <div className="form-group">
              <label className="form-label">New Password</label>
              <input type="password" className="form-input" value={password} onChange={e => setPassword(e.target.value)} placeholder="Minimum 8 characters" required autoFocus />
            </div>
            <div className="form-group">
              <label className="form-label">Confirm Password</label>
              <input type="password" className="form-input" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Re-enter password" required />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, marginTop: 8 }}>
              <button type="submit" className="btn btn-primary btn-lg" style={{ minWidth: 180, width: 'auto' }} disabled={loading}>
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </div>
            <div className="login-toggle">
              <Link to="/login">Back to Sign In</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
